import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import CommonSlider from "../LocalMusic/CommonSlider";
// import CommonSlider from "./CommonSlider";

export default function SecondSlider({ sliderData, onViewAll }) {
    const businesses = sliderData?.data?.data?.businesses || [];

    console.log("businessesbusinessesbusinesses", businesses)


    if (!businesses.length) return null;

    return (
        <>
            <div
                className="delivery_restaurant_header"
            >
                <h2>Deals</h2>
            </div>

            <div uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    loop={true}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    navigation={true}
                    breakpoints={{
                        0: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1200: { slidesPerView: 3 },
                    }}
                    className="pt-5 pb-3 pb-md-5 localmusic-swiper mt-0"
                >
                    {businesses?.map((item, index) => (
                        <SwiperSlide key={item.id || index}>
                            <CommonSlider sliderData={item} />
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="d-flex justify-content-end mt-0">
                    <button className="view-all-btn" onClick={onViewAll}>
                        View All <i className="fa-solid fa-arrow-right"></i>
                    </button>
                </div>
            </div>
        </>
    );
}
